import { makeStyles } from '@material-ui/core';

export const useStyle = ({ size = 'sm' }) => {
  const sizeData = {
    xl: {
      paddingTop: 15,
      paddingBottom: 15,
    },
    lg: {
      paddingTop: 10,
      paddingBottom: 10,
    },
    md: {
      paddingTop: 7,
      paddingBottom: 7,
    },
    sm: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  };
  return makeStyles(() => ({
    root: {
      '& .MuiInputBase-root': sizeData[size as keyof typeof sizeData],
    },
  }));
};
